import { Link } from "react-router-dom";
import { Logo, TrustBar } from "@/components/brand";
import { useAuth } from "@/context/AuthContext";

const COLS = [
  ["Sports", [["Football", "/sports?sport=football"], ["Cricket", "/sports?sport=cricket"], ["Tennis", "/sports?sport=tennis"], ["Basketball", "/sports?sport=basketball"], ["All Sports", "/sports"]]],
  ["Casino", [["Casino Games", "/casino"], ["Live Casino", "/live-casino"], ["Promotions", "/promotions"], ["VIP Club", "/vip"]]],
  ["Support", [["Help Center / FAQ", "/faq"], ["Contact Us", "/account/support"], ["Responsible Gaming", "/legal/responsible-gaming"], ["Complaints", "/legal/complaints"]]],
  ["Legal", [["Terms & Conditions", "/legal/terms"], ["Privacy Policy", "/legal/privacy"], ["KYC / AML Policy", "/legal/kyc-aml"], ["Licensing", "/legal/licensing"]]],
];

export default function Footer() {
  const { config } = useAuth();
  const comp = config?.compliance || {};
  return (
    <footer data-testid="site-footer" className="border-t border-cr-line bg-[#0a0b0b]">
      <div className="mx-auto max-w-7xl px-5 py-12">
        <div className="grid gap-10 md:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div>
            <Logo className="h-14" />
            <p className="mt-4 max-w-xs text-sm text-cr-ink/70">{config?.footer?.about}</p>
            <p className="mt-4 text-xs text-cr-muted">Support: {config?.support?.email}</p>
          </div>
          {COLS.map(([title, links]) => (
            <div key={title}>
              <h4 className="mb-4 text-sm font-bold text-cr-gold">{title}</h4>
              <ul className="space-y-2.5 text-sm text-cr-ink/80">
                {links.map(([l, to]) => (
                  <li key={l}><Link data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`} to={to} className="hover:text-cr-gold">{l}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 grid gap-3 rounded-xl border border-cr-line bg-cr-surface p-4 text-xs leading-relaxed text-cr-muted md:grid-cols-3">
          <p><b className="text-cr-ink">Age restriction:</b> {comp.min_age || 18}+ only. Underage users cannot register.</p>
          <p><b className="text-cr-ink">Availability:</b> Not available in {(comp.blocked_countries || []).join(", ") || "restricted regions"} or wherever online gaming is prohibited.</p>
          <p><b className="text-cr-ink">Licensing:</b> {comp.license_text || "CRBETS is a licensed operator."}</p>
        </div>
        <div className="mt-8 flex flex-col gap-2 text-xs text-cr-muted sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} CR BETS. All rights reserved.</span>
          <span>18+ only. Gambling can be addictive — please play responsibly.</span>
        </div>
        <TrustBar className="mt-6" />
      </div>
    </footer>
  );
}
